export class FailedDoctorFeesViewModel {
    InvoiceNumber: string;
    ActionId: number;
    VendorCode: string;
    ItemTitle: string;
    NetAmount: number;
    RowCount: number;
}
